define([
    "core/urls",
    "core/utilities"
], function (
    urls,
    utilities    
) {
    let nodes = {
        body: document.querySelector("body"),
        mainWrapper: document.querySelector(".project-survey"),
        frames: document.querySelectorAll(".frames .frame"),
        questionFrames: document.querySelectorAll(".frames .frame.question"),
        commentFrame: document.querySelector(".frames .frame.comment"),
        surveyOptions: document.querySelectorAll(".options .option"),
        skipButtons: document.querySelectorAll("button.advance"),
        prevButtons: document.querySelectorAll(".sub-controls .previous"),
        currentQuestionNumber: document.querySelector(".current-question"),
        totalQuestions: document.querySelector(".total-questions"),
        completionProgressIncomplete: document.querySelector(".completion-progress.incomplete"),
        completionProgressDone: document.querySelector(".completion-progress.done"),
        commentBox: document.querySelector(".comment-box"),
        commentSubmit: document.querySelector(".frame.comment .submit"),
        googleWrapper: document.querySelector(".google-wrapper"),
        googleCheckbox: document.querySelector(".google-wrapper #googleRedirect"),
    }

    let state = {
        currentFrame: 0,
        percentageComplete: 0,
        lastSelected: 0
    }

    let responses = {};
    let isPreview = nodes.mainWrapper.getAttribute("data-is-preview");
    let questionCount = nodes.questionFrames.length;

    let fallbackCopyTextToClipboard = (text) => {
        var textArea = document.createElement("textarea");
        textArea.value = text;
      
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
      
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
      
        document.body.removeChild(textArea);
      }
      
      let copyTextToClipboard = (text) => {
        if (!navigator.clipboard) {
            fallbackCopyTextToClipboard(text);
          return;
        }

        navigator.clipboard.writeText(text);
      }

    let advanceFrame = () => {
        state.currentFrame ++;

        if((state.currentFrame + 1) > questionCount) {
            nodes.completionProgressIncomplete.classList.add("hide");
            nodes.completionProgressDone.classList.remove("hide");
        } else {
            if((state.currentFrame + 1) === questionCount) {
                let scoreTotal = 0;
                let scoreCount = 0;
                Object.keys(responses).forEach((key) => {
                    if(key !== "comment") {
                        scoreTotal += responses[key] * 1;
                        scoreCount ++;
                    }
                })
                
                if(nodes.googleWrapper) {
                    let skippedCategories = 0;
                    // count how many questions were skipped so they are not included in google checkbox calculation below
                    Object.keys(responses).forEach(key => {
                        if(responses[key] === "" && key !== 'comment') skippedCategories ++;
                    })

                    if((scoreTotal / (scoreCount - skippedCategories)) >= 4) {
                        nodes.googleWrapper.classList.remove('hide');
                    } else {
                        nodes.googleWrapper.classList.add('hide');
                    }
                }                
            }
            nodes.currentQuestionNumber.innerHTML = state.currentFrame + 1;
        }
        
        nodes.frames[state.currentFrame].scrollIntoView({behavior: "smooth"});
    }

    let submitForm = () => {
        let currentQuestion = state.currentFrame;
        if(nodes.questionFrames[currentQuestion]) {
            let currentSelection = nodes.questionFrames[currentQuestion].querySelector(".option.selected");
            let selectedValue = currentSelection ? currentSelection.getAttribute("data-value") : '';
            responses[currentQuestion] = selectedValue;
        }

        let form = nodes.frames[state.currentFrame].querySelector("form");

        let commentField = form.querySelector("textarea");

        // don't submit comment if empty
        if (commentField && commentField.value === '') {
            advanceFrame();
            return;
        }

        if(form && isPreview === "False") {
            let selectBox = form.querySelector("select");
            if(selectBox) {
                selectBox.value = responses[currentQuestion];
            }

            if (commentField && commentField.value !== '') {
                commentField.value = utilities.sanitizeData(commentField.value);
            }

            fetch(form.action, {
                method:'post', 
                body: new FormData(form),
                redirect: 'manual'
            })
            .then(response => {
                if(response.type === "opaqueredirect") {
                    window.location.href = "/projects/rejected";
                }
            });
        }

        advanceFrame();

        if(nodes.googleCheckbox && nodes.googleCheckbox.checked) {
            copyTextToClipboard(nodes.commentBox.value);
            window.open(nodes.googleCheckbox.dataset.redirect, '_blank').focus();
        } 
    }

    let createEventListeners = () => {
        nodes.surveyOptions.forEach(option => {
            option.addEventListener("click", (event) => {
                let parent = option.parentElement;
                let selected = parent.querySelector(".option.selected");
    
                state.lastSelected = state.currentFrame;
    
                if(selected) {
                    selected.classList.remove("selected");
                }
    
                option.classList.add("selected");
    
                submitForm();
            })
        })
    
        if(nodes.commentFrame) {
            nodes.commentSubmit.addEventListener("click", (event) => {
                event.preventDefault();
                submitForm();
            })
        }
    
        nodes.prevButtons.forEach((button) => {
            button.addEventListener("click", () => {
                state.currentFrame --;
                nodes.frames[state.currentFrame].scrollIntoView({behavior: "smooth"});
    
                nodes.currentQuestionNumber.innerHTML = state.currentFrame + 1;
    
                nodes.completionProgressIncomplete.classList.remove("hide");
                nodes.completionProgressDone.classList.add("hide");
            })
        })
    
        nodes.skipButtons.forEach((button) => {
            button.addEventListener("mouseup", () => {
                advanceFrame();
            });
        })
    
        // prevent horizontal scrolling
        nodes.body.addEventListener('wheel', (e) => {
            if(e.wheelDeltaX !== 0) {
                e.preventDefault();
                e.stopPropagation();
            }
        }, {passive: false});
    }

    return {
        init: function () {
            nodes.questionFrames.forEach((frame, index) => {
                let currentQuestion = index;
                responses[currentQuestion] = "";
            })
        
            if(nodes.commentFrame) {
                questionCount ++;
                responses.comment = "";

                utilities.addCharacterCount(".comment-box", 1000);
            }
        
            nodes.totalQuestions.innerHTML = questionCount;

            createEventListeners();
        },
    };
})